import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Personnel_Details_Form.css";
import { Link } from "react-router-dom";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
  GetByUserId,
  Update,
} from "../../../../../../../../src/features/admin/quality_management/resource_requirement/personal_detail/Slice";
import {
  allDesignation,
  allQualification,
  allSpecialization,
  allRelevant_Training,
  allUsers,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm, useWatch } from "react-hook-form";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";

function Personnel_Details_Form({ handleClose, fetchCustomers }) {
  const dispatch = useDispatch();
  const all_designation = useSelector((state) => state.common.all_designation);
  const all_qualification = useSelector(
    (state) => state.common.all_qualification,
  );
  const all_specialization = useSelector(
    (state) => state.common.all_specialization,
  );
  const all_relevant_training = useSelector(
    (state) => state.common.all_relevant_training,
  );
  const authdetails = useSelector((state) => state.auth);

  const all_users = useSelector((state) => state.common.all_users);

  const isAdmin = authdetails?.role_id === 1;

  useEffect(() => {
    dispatch(allDesignation());
    dispatch(allQualification());
    dispatch(allSpecialization());
    dispatch(allRelevant_Training());
    dispatch(allUsers());
    dispatch(GETAuthLogin());
  }, [dispatch]);

  const defaultValues = {
    degree: null,
    training_certificate: null,
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    reset,
    watch,
    getValues,
    control,
  } = useForm({ defaultValues });

  const [showError, setShowError] = useState({});
  const [previews, setPreviews] = useState({});
  const [success, setSuccess] = useState(false);
  const [degreePreview, setDegreePreview] = useState(null);
  const [trainingPreview, setTrainingPreview] = useState(null);

  const degreeInputRef = useRef(null);
  const trainingInputRef = useRef(null);
  const [personnelId, setPersonnelId] = useState(null);

  const selectedUserId = useWatch({
    control,
    name: "user_id",
  });

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const data = useSelector((state) => state.personnel_details.single_data);
  useEffect(() => {
    if (data) {
      // Prefill form
      setValue("name", data.name);
      setValue("contact_no", data.contact_no);
      setValue("email", data.email);
      setValue("experience", data.experience);
      setValue("designation_id", data.designation_id);
      setValue("qualification_id", data.qualification_id);
      setValue("specialization_id", data.specialization_id);
      setValue("relevant_training_id", data.relevant_training_id);

      // previews (optional)
      if (data.degree) {
        setDegreePreview(`${process.env.REACT_APP_IMG_URL}${data.degree}`);
      }

      if (data.training_certificate) {
        setTrainingPreview(
          `${process.env.REACT_APP_IMG_URL}${data.training_certificate}`,
        );
      }
    } else {
      // No personnel detail → reset form (create mode)
      reset({
        user_id: selectedUserId,
        name: "",
        contact_no: "",
        email: "",
        experience: "",
        designation_id: null,
        qualification_id: null,
        specialization_id: null,
        relevant_training_id: null,
        degree: null,
        training_certificate: null,
      });

      setDegreePreview(null);
      setTrainingPreview(null);
    }
  }, [data]);
  useEffect(() => {
    if (!selectedUserId) return;
    dispatch(GetByUserId(selectedUserId));

    // dispatch(GetByUserId(selectedUserId)).then((res) => {
    //   const data = res?.payload?.data;

    //   if (data) {
    //     // Prefill form
    //     setValue("name", data.name);
    //     setValue("contact_no", data.contact_no);
    //     setValue("email", data.email);
    //     setValue("experience", data.experience);
    //     setValue("designation_id", data.designation_id);
    //     setValue("qualification_id", data.qualification_id);
    //     setValue("specialization_id", data.specialization_id);
    //     setValue("relevant_training_id", data.relevant_training_id);

    //     // previews (optional)
    //     if (data.degree) {
    //       setDegreePreview(`${process.env.REACT_APP_IMG_URL}${data.degree}`);
    //     }

    //     if (data.training_certificate) {
    //       setTrainingPreview(
    //         `${process.env.REACT_APP_IMG_URL}${data.training_certificate}`,
    //       );
    //     }
    //   } else {
    //     // No personnel detail → reset form (create mode)
    //     reset({
    //       user_id: selectedUserId,
    //       name: "",
    //       contact_no: "",
    //       email: "",
    //       experience: "",
    //       designation_id: null,
    //       qualification_id: null,
    //       specialization_id: null,
    //       relevant_training_id: null,
    //       degree: null,
    //       training_certificate: null,
    //     });

    //     setDegreePreview(null);
    //     setTrainingPreview(null);
    //   }
    // });
  }, [selectedUserId]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      // 🔹 Link personnel with user
      formData.append("user_id", selectedUserId);

      // 🔹 Basic fields
      formData.append("name", data.name);
      formData.append("contact_no", data.contact_no);
      formData.append("email", data.email);
      formData.append("experience", data.experience);

      // 🔹 Relations
      formData.append("designation_id", data.designation_id);
      formData.append("qualification_id", data.qualification_id);
      formData.append("specialization_id", data.specialization_id);
      formData.append("relevant_training_id", data.relevant_training_id);

      formData.append("degree", data.degree[0]);

      formData.append("training_certificate", data.training_certificate[0]);

      let res;
      if (personnelId) {
        res = await dispatch(
          Update({
            id: personnelId,
            sendData: formData,
          }),
        );
      } else {
        res = await dispatch(Create(formData));
      }

      // ✅ SUCCESS (same style as old code)
      if (res?.meta?.requestStatus === "fulfilled") {
        await fetchCustomers();

        // clear RHF values
        reset();
        setValue("degree", null);
        setValue("training_certificate", null);

        // clear previews
        setDegreePreview(null);
        setTrainingPreview(null);

        // clear actual file inputs
        if (degreeInputRef.current) degreeInputRef.current.value = "";
        if (trainingInputRef.current) trainingInputRef.current.value = "";

        // show success toaster
        setSuccess(true);
      } else {
        setShowError(res?.payload?.errors || {});
      }
    } catch (error) {
      console.error("Personnel submit error:", error);
    }
  };

  const fileInputRef = useRef(null);

  const openFileManager = () => {
    fileInputRef.current.click();
  };

  const fileRef = useRef(null);

  const handleDegreeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("degree", file, { shouldValidate: true });
      setDegreePreview(URL.createObjectURL(file));
    }
  };

  const handleTrainingChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("training_certificate", file, { shouldValidate: true });
      setTrainingPreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      {/* ================= PERSONAL DETAILS ================= */}
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">
            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Users</Form.Label>
                <Controller
                  name="user_id"
                  control={control}
                  rules={{ required: "User is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_users}
                      value={
                        all_users?.find((o) => o.value === field.value) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.user_id && (
                  <Form.Text className="text-danger">
                    {errors.user_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name.message}</small>
                )}{" "}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Designation</Form.Label>
                <Controller
                  name="designation_id"
                  control={control}
                  rules={{ required: "Designation is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_designation}
                      value={
                        all_designation?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.designation_id && (
                  <Form.Text className="text-danger">
                    {errors.designation_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Experience</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Experience"
                  {...register("experience", {
                    required: "Experience is required",
                  })}
                  onKeyDown={(e) => {
                    const value = e.target.value;

                    // Allow control keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                      ].includes(e.key)
                    ) {
                      return;
                    }

                    // Allow numbers
                    if (/^[0-9]$/.test(e.key)) {
                      return;
                    }

                    // Allow ONE decimal point
                    if (e.key === "." && !value.includes(".")) {
                      return;
                    }

                    // Block everything else
                    e.preventDefault();
                  }}
                />
                {errors.experience && (
                  <small className="text-danger">
                    {errors.experience.message}
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Qualification</Form.Label>
                <Controller
                  name="qualification_id"
                  control={control}
                  rules={{ required: "Qualification is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_qualification}
                      value={
                        all_qualification?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.qualification_id && (
                  <Form.Text className="text-danger">
                    {errors.qualification_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Specialization</Form.Label>
                <Controller
                  name="specialization_id"
                  control={control}
                  rules={{ required: "Qualification is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_specialization}
                      value={
                        all_specialization?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.specialization_id && (
                  <Form.Text className="text-danger">
                    {errors.specialization_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach File (Degree)</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("degree", {
                      required:
                        typeof getValues("degree") === "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />

                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>

                {errors.degree && (
                  <small className="text-danger">{errors.degree.message}</small>
                )}
                {(() => {
                  const fileValue = watch("degree");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="preview-container">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* <div className="image_holder">
                  <img
                    className="img_preview"
                    src={
                      degreePreview || "/assets/images/other/dummy-image.png"
                    }
                    alt="Degree Preview"
                  />
                </div> */}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Relevant Training</Form.Label>
                <Controller
                  name="relevant_training_id"
                  control={control}
                  rules={{ required: "Relevant training is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_relevant_training}
                      value={
                        all_relevant_training?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.relevant_training_id && (
                  <Form.Text className="text-danger">
                    {errors.relevant_training_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Training Certificate</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("training_certificate", {
                      required:
                        typeof getValues("training_certificate") === "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />

                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>

                {errors.training_certificate && (
                  <small className="text-danger">
                    {errors.training_certificate.message}
                  </small>
                )}
                {(() => {
                  const fileValue = watch("training_certificate");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="preview-container">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {/* <div className="image_holder">
                  <img
                    className="img_preview"
                    src={
                      trainingPreview || "/assets/images/other/dummy-image.png"
                    }
                    alt="Training Preview"
                  />
                </div> */}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Mobile No</Form.Label>
                <Form.Control
                  placeholder="Mobile No"
                  {...register("contact_no", {
                    required: "Mobile No is required",
                    minLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                  })}
                />
                {errors.contact_no && (
                  <small className="text-danger">
                    {errors.contact_no.message}
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="col-xl-4 col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  placeholder="Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email format",
                    },
                  })}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email.message}</small>
                )}{" "}
              </Form.Group>
            </div>
          </div>

          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={() =>
                    reset({
                      user_id: "",
                      name: "",
                      contact_no: "",
                      email: "",
                      experience: "",
                      designation_id: null,
                      qualification_id: null,
                      specialization_id: null,
                      relevant_training_id: null,
                      degree: null,
                      training_certificate: null,
                    })
                  }
                >
                  Reset
                </Button>
                {/* <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button> */}

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Personnel_Details_Form;
